import React from 'react';
import GeckoFieldBase from '../_base.jsx';

//https://github.com/gpbl/react-day-picker
//http://react-day-picker.js.org/docs/
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import GeckoDate from '../../../../../services/gecko-date';
// import this after the css above so we can overwrite it

import './date.scss';

class GeckoFieldDate extends GeckoFieldBase {
  displayFormat() {
    return this.field().display_format || 'YYYY/MM/DD';
  }

  format() {
    return this.field().format || 'YYYY/MM/DD';
  }

  prepareValue(value) {
    if (!value) {
      return null;
    }
    return new GeckoDate(value, this.format(), {
      enableUTC: this.field().enableUTC,
    })
      .startOf('day')
      .format(this.format());
  }

  handleChange(value) {
    return this.props.handler.bind(
      this,
      this.field().key,
      this.prepareValue(value)
    )();
  }

  value() {
    // get nested object values from a key like 'nested.object.value' to target {nested: {object: {value: 'test'}}}
    const keyFragments = this.field().key.split('.');
    const getValue = (obj, key) => obj[key];
    const value = keyFragments.reduce(getValue, this.props.values);
    if (!value) {
      return '';
    }
    const parsed = new GeckoDate(value, this.format(), {
      enableUTC: this.field().enableUTC,
    }).moment;
    const newValue = parsed.isValid() ? parsed.toDate() : '';
    return newValue;
  }

  parseDate(str) {
    const parsed = new GeckoDate(str, this.displayFormat(), {
      enableUTC: this.field().enableUTC,
    }).moment;

    if (parsed.isValid()) {
      return parsed.toDate();
    }
    return null;
  }

  formatDate(date) {
    if (!date) {
      return null;
    }
    return new GeckoDate(date, this.displayFormat(), {
      enableUTC: this.field().enableUTC,
    }).toString();
  }

  render() {
    const dayPickerProps = {
      todayButton: 'Go to Today',
      enableOutsideDays: true,
      modifiers: {
        monday: { daysOfWeek: [1] },
      },
    };

    return (
      <DayPickerInput
        id={this.renderId()}
        className="col-sm form-control gecko-ui-material"
        value={this.value()}
        onDayChange={this.handleChange.bind(this)}
        parseDate={this.parseDate.bind(this)}
        formatDate={this.formatDate.bind(this)}
        placeholder={this.field().placeholder || this.displayFormat()}
        dayPickerProps={dayPickerProps}
        disabled={this.isDisabled()}
      />
    );
  }
}

export default GeckoFieldDate;
